/**
 * True if the string looks like our API-built report HTML (not a plain-text error body).
 * @param {string} html
 */
export function isUsableReportPrintHtml(html) {
  const s = String(html || '').trim();
  if (s.length < 800) return false;
  const head = s.slice(0, 4000).toLowerCase();
  if (
    head.includes('print version is not available') ||
    head.includes('invalid or expired') ||
    head.includes('sessionid query') ||
    head.includes('database not configured')
  ) {
    return false;
  }
  if (!/<!doctype/i.test(s) && !/<html[\s>/]/i.test(s)) return false;
  return /pdf-report|career intelligence profile/i.test(head);
}

/**
 * Opens the browser print dialog for a full HTML document (e.g. API-built report).
 * Uses an off-screen iframe with real dimensions so layout/print matches PDF (0×0 iframes can fail in some browsers).
 * @param {string} html
 * @returns {boolean} true if a print was attempted from a usable document
 */
export function printFullDocumentHtml(html) {
  if (!isUsableReportPrintHtml(html)) return false;
  const s = String(html || '').trim();
  const iframe = document.createElement('iframe');
  iframe.setAttribute('title', 'Career report print');
  iframe.setAttribute('aria-hidden', 'true');
  /* Real size off-screen — width/height 0 caused “only the app screen” style output in some environments. */
  iframe.style.cssText =
    'position:fixed;left:-12000px;top:0;width:210mm;min-height:297mm;border:0;margin:0;padding:0;opacity:0;pointer-events:none;z-index:-1;overflow:hidden;';
  document.body.appendChild(iframe);
  const win = iframe.contentWindow;
  const doc = iframe.contentDocument;
  if (!win || !doc) {
    iframe.remove();
    return false;
  }
  doc.open();
  doc.write(s);
  doc.close();
  let fired = false;
  const runPrint = () => {
    if (fired) return;
    fired = true;
    const invoke = () => {
      try {
        win.focus();
        win.print();
      } catch {
        /* ignore */
      }
      window.setTimeout(() => {
        try {
          iframe.remove();
        } catch {
          /* ignore */
        }
      }, 90_000);
    };
    requestAnimationFrame(() => {
      requestAnimationFrame(invoke);
    });
  };
  iframe.onload = () => runPrint();
  window.setTimeout(() => runPrint(), 900);
  return true;
}
